import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ReferralComponent } from './referral.component';
import { RequestReferralComponent } from './request-referral/request-referral.component';
import { MyReferralRequestsComponent } from './generic-components-referral/my-referral-requests/my-referral-requests.component';
import { SummaryComponent } from './generic-components-referral/summary/summary.component';
import { ReferralReadyComponent } from './generic-components-referral/referral-ready/referral-ready.component';
import { PendingAppointmentRequestsComponent } from './generic-components-referral/pending-appointment-requests/pending-appointment-requests.component';
import { ConfirmedAppointmentsComponent } from './generic-components-referral/confirmed-appointments/confirmed-appointments.component';
import { MemberEligibilityComponent } from './member-eligibility/member-eligibility.component';

const referralRoutes: Routes = [
	{
		path: '',
		component: ReferralComponent,
		data: {
			title: 'Referral',
		},
		children: [
			{
				path: '',
				redirectTo: 'current/summary',
				pathMatch: 'full',
			},
			{
				path: 'request',
				component: RequestReferralComponent,
				data: {
					title: 'Request Referral',
				},
			},
			{
				path: ':section/summary',
				component: SummaryComponent,
				data: {
					title: 'Referrals',
				},
			},
			{
				path: ':section/requests',
				component: MyReferralRequestsComponent,
				data: {
					title: 'Referral Requests',
				},
			},
			{
				path: ':section/ready',
				component: ReferralReadyComponent,
				data: {
					title: 'Referral Ready',
				},
			},
			{
				path: ':section/pending/appointment/request',
				component: PendingAppointmentRequestsComponent,
				data: {
					title: 'Appointment Requests',
				},
			},
			{
				path: ':section/confirmed/appointments',
				component: ConfirmedAppointmentsComponent,
				data: {
					title: 'Confirmed Appointments',
				},
			},
			{
				path: 'eligibility',
				component: MemberEligibilityComponent,
				data: {
					title: 'Referrals',
				},
			},
		],
	},
];

@NgModule({
	imports: [RouterModule.forChild(referralRoutes)],
	exports: [RouterModule],
})
export class ReferralRoutingModule {}
